export function takeTokenFromUrl(win = window) {
  const url = new URL(win.location.href);
  const fragment = new URLSearchParams(url.hash.slice(1));
  const inFragment = fragment.has('token');
  const inQuery = url.searchParams.has('token');
  if (!inFragment && !inQuery) return null;
  const token = inFragment ? fragment.get('token') : url.searchParams.get('token');
  url.searchParams.delete('token');
  if (inFragment) {
    fragment.delete('token');
    url.hash = fragment.toString();
  }
  win.history.replaceState(win.history.state, '', url.toString());
  return token;
}

export function initialAuthStatus({ pathname, inIframe, isDev, bypass, token }) {
  if (pathname.startsWith('/admin')) return 'allowed';
  if (inIframe || isDev) return 'allowed';
  if (bypass === 'true') return 'allowed';
  return token ? 'checking' : 'blocked';
}

export async function checkContentPass(token, fetchImpl = window.fetch) {
  try {
    const response = await fetchImpl('/api/content-pass', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token }),
    });
    if (!response.ok) return false;
    return (await response.json())?.ok === true;
  } catch { return false; }
}
